import React from 'react';
import { BaseResponsiveSearchCard } from '../Base';
import { SearchCard } from '../types';
import {
  Title,
  GrayUIText,
  Price,
  GrayPrice,
  BottomContent,
} from '../Base/styles';
import {
  BoxConditionIcon,
  TruckIcon,
  MapMarkerIcon,
  CartIcon,
} from '../../../../assets';
import { theme } from '../../../../theme';
import styled from 'styled-components';
import { Pill } from '../../../basePill';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings[2].rem};
  margin: ${theme.spacings[2].rem};
`;

export const BuyNowResponsiveSearchCard: React.FC<SearchCard<'BuyNow'>> = ({
  title,
  condition,
  location,
  isDelivery,
  grayPrice,
  price,
  data,
  type,
  ...props
}) => {
  return (
    <BaseResponsiveSearchCard {...props}>
      <Content>
        <Title>{title}</Title>
        <Pill
          backgroundColor={theme.colors.tints.systemBlue[6]}
          icon={CartIcon}
        >
          Buy Now
        </Pill>
        <div>
          {grayPrice && <GrayPrice>{grayPrice}</GrayPrice>}
          <Price>{price}</Price>
        </div>
        <BottomContent>
          <GrayUIText>
            <BoxConditionIcon
              width={16}
              fill={theme.colors.neutrals.solidGrays[3]}
            />
            {condition}
          </GrayUIText>
          <GrayUIText>
            {isDelivery ? (
              (condition as string).length < 15 && (
                <>
                  <TruckIcon
                    width={16}
                    fill={theme.colors.neutrals.solidGrays[3]}
                  />
                  Delivery
                </>
              )
            ) : (
              <>
                <MapMarkerIcon
                  width={16}
                  fill={theme.colors.neutrals.solidGrays[3]}
                />
                {location}
              </>
            )}
          </GrayUIText>
        </BottomContent>
      </Content>
    </BaseResponsiveSearchCard>
  );
};
